import React from "react";
import cx from "classnames";
import qs from "query-string";

import _U from "@util/utilities";

export default class Paging extends React.Component {
    handlePageClicked(page, e) {
        e.preventDefault();
        this.props.pageCallback && this.props.pageCallback(page < 1 ? 1 : page);
    }

    render() {
        const { paging, type } = this.props;
        const pagingItems = [];
        if (paging) {
            for (let i = paging.startPageNo; i <= paging.endPageNo; i++) {
                if (type === "FRONT") {
                    pagingItems.push(
                        <span>
                            <button onClick={this.handlePageClicked.bind(this, i)} className={cx({ "is-selected": paging.pageNo === i })}>
                                {i}
                            </button>
                        </span>
                    );
                } else {
                    pagingItems.push(
                        <li className={cx({ "page-item": true, active: paging.pageNo === i })} key={i}>
                            <a onClick={this.handlePageClicked.bind(this, i)} className="page-link">
                                {i}
                            </a>
                        </li>
                    );
                }
            }
        }

        return (
            <>
                {paging && (
                    <>
                        {type === "FRONT" ? (
                            <div className="pagingWrap1">
                                <div className="paging1">
                                    <button onClick={this.handlePageClicked.bind(this, 1)}>
                                        <img src="/assets/images/ico_first.gif" alt="" />
                                    </button>
                                    <button onClick={this.handlePageClicked.bind(this, paging.prevBlockNo)}>
                                        <img src="/assets/images/ico_prev.gif" alt="" />
                                    </button>
                                    {pagingItems}
                                    <button onClick={this.handlePageClicked.bind(this, paging.nextBlockNo)}>
                                        <img src="/assets/images/ico_next.gif" alt="" />
                                    </button>
                                    <button onClick={this.handlePageClicked.bind(this, paging.finalPageNo)}>
                                        <img src="/assets/images/ico_last.gif" alt="" />
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <ul className="pagination justify-content-center">
                                <li className="page-item pagination-first " onClick={this.handlePageClicked.bind(this, 1)}>
                                    <a className="page-link">««</a>
                                </li>
                                <li className="page-item pagination-prev " onClick={this.handlePageClicked.bind(this, paging.prevBlockNo)}>
                                    <a className="page-link">«</a>
                                </li>

                                {pagingItems}

                                <li className="page-item pagination-next" onClick={this.handlePageClicked.bind(this, paging.nextBlockNo)}>
                                    <a className="page-link">»</a>
                                </li>
                                <li className="page-item pagination-first" onClick={this.handlePageClicked.bind(this, paging.finalPageNo)}>
                                    <a className="page-link">»»</a>
                                </li>
                            </ul>
                        )}
                    </>
                )}
            </>
        );
    }
}

export const ToPage = (location, navigate, params) => {
    navigate(`${location.pathname}?q=${_U.encode(params)}`);
};

export const GetParams = (location) => {
    const { search } = location;
    const p = qs.parse(search);
    if (!p.q) return null;
    return _U.decode(p.q);
};
